import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';
@Component({
  selector: 'app-tool-shifting-listing',
  templateUrl: './tool-shifting-listing.component.html',
  styleUrls: ['./tool-shifting-listing.component.scss']
})
export class ToolShiftingListingComponent {
breadcrumb = [
  {
    title: "Tool Shfiting  Details",
    subTitle: "Dashboard",
  },
];
role:any;
ToolshiftingData:any[]=[];
filterval: string;
  packagedata: any;
  constructor(
    public _apiService: ApiServiceService,
    private confirmationService: ConfirmationService,
    public _utility: AppUtility,
    public _route:Router
  ) { }
ngOnInit(){
  this.role = JSON.parse(localStorage.getItem("UserObject"));
  console.log("role", this.role.roleName);
  this.getshiftingdata();
}
reset(dt2) {
  dt2.reset();
  this.filterval = ''
}
getshiftingdata(){
  this._utility.loader(true)
  this._apiService.toolshiftingdata().then((res:any)=>{
  console.log(res,"shifting data");
  if (res.success) {
        this._utility.loader(false)
        this.ToolshiftingData = res.returnValue;
        console.log(this.ToolshiftingData, "error");

      } else {
        this._apiService.showMessage(res.message, "error");
        this._utility.loader(false)
      }
    })
      .catch((error: any) => {
        console.log('api error', error);
        this._apiService.showMessage("Something went wrong. Please try again.", "error");
        this._utility.loader(false)
      })
    }
  generatetoolloan() {
  const selectedData = this.ToolshiftingData.filter(tool => tool.selected);
  console.log(selectedData);
  
  if (selectedData.length > 0) {
    const id = selectedData[0].toolLoanMasterId

    this._utility.loader(true);
      this._route.navigate(['/tool-loan-agreement-form'], { state: { packagedata: selectedData } })
      this._utility.loader(false);

  }
  else {
    this._apiService.showMessage("please select atleast one checkbox", "error")
  }
}
}
